import CenteredLoadingSpinner from 'loadingIndicator/CenteredLoadingSpinner';
import React from 'react';
import styles from './PlayerOverlayCommon.module.css';
import {
  PlayerDebugPanel,
  usePlayerOverlayCommon,
  type PlayerOverlayCommonProps,
} from './usePlayerOverlayCommon';

export type { PlayerOverlayCommonProps };

/**
 * PlayerOverlayCommon is rendered over top of a video player, and shows things
 * common to all video players in all contexts (video page, video wall, event player,
 * etc...).
 */
const PlayerOverlayCommon: React.FC<PlayerOverlayCommonProps> = (props) => {
  const { playbackController, playingCamera, locationIsLocal, bandwidthWarning } = props;
  const { loading, stream, debugInfo, noStreamMessage } = usePlayerOverlayCommon(props);

  return (
    <div className={styles.overlayWrapper}>
      {stream === undefined && debugInfo === undefined && (
        <div className={styles['empty-playlist-wrapper']} data-test-id="no-stream-message">
          <p>{noStreamMessage}</p>
        </div>
      )}
      {loading && stream && (
        <CenteredLoadingSpinner
          style={{ position: 'absolute', top: 0, left: 0 }}
          size={32}
          delay={200}
        />
      )}
      {debugInfo && (
        <PlayerDebugPanel
          playbackController={playbackController}
          playingCamera={playingCamera}
          locationIsLocal={locationIsLocal}
          bandwidthWarning={bandwidthWarning}
          {...debugInfo}
        />
      )}
    </div>
  );
};

export default React.memo(PlayerOverlayCommon);
